import React from 'react';
import Publication from '../../components/publication';
import { getProp, getPropAsset, getPropMarked } from '../utils';

const PublicationPreview = (props) => {
  const title = getProp(props, 'title');
  const abstract = getPropMarked(props, 'abstract');
  const placeDate = getProp(props, 'placeDate');
  const pdf = getPropAsset(props, 'pdf');
  const link = getProp(props, 'link');

  return (
    <div className="container-xl pt-5">
      <Publication {...{ title, abstract, placeDate, pdf, link }} />
    </div>
  );
};

export default PublicationPreview;
